// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f2918d89","453":"3bb50805","455":"4788edee","977":"8d7ac325"}[chunkId] + ".chunk.js";
};